"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromUTC = exports.getLastPublishedMessage = exports.getLastSavedMessage = exports.millisToUnit = exports.TimeUnits = void 0;
var TimeUnits;
(function (TimeUnits) {
    TimeUnits[TimeUnits["SECOND"] = 1000] = "SECOND";
    TimeUnits[TimeUnits["MINUTE"] = 60000] = "MINUTE";
    TimeUnits[TimeUnits["HOUR"] = 3600000] = "HOUR";
    TimeUnits[TimeUnits["DAY"] = 86400000] = "DAY";
    TimeUnits[TimeUnits["WEEK"] = 604800000] = "WEEK";
    TimeUnits[TimeUnits["MONTH"] = 2592000000] = "MONTH";
    TimeUnits[TimeUnits["YEAR"] = 31104000000] = "YEAR";
})(TimeUnits = exports.TimeUnits || (exports.TimeUnits = {}));
/**
 * Convert a number of milliseconds to a given unit.
 * Optionally round down to an amount of the rounded unit
 * @param millis - The milliseconds to round
 * @param unit - The unit to round the milliseconds to
 * @param round? - The number of `unit` to round the result to
 */
const millisToUnit = (millis, unit, round) => {
    let formatted = Math.floor(millis / unit);
    if (round) {
        formatted = Math.min(Math.floor(formatted / round) * round, formatted);
    }
    return formatted;
};
exports.millisToUnit = millisToUnit;
/**
 * Calculate the string to display for saved status.
 *
 * @param lastSaved : Date that is the last save time.
 */
const getLastSavedMessage = (lastSaved) => {
    const now = new Date();
    const millisDifferent = now.getTime() - lastSaved.getTime();
    if (millisDifferent < (TimeUnits.SECOND * 5)) {
        return `a few seconds ago`;
    }
    else if (millisDifferent < (TimeUnits.SECOND * 30)) {
        const fiveSeconds = (0, exports.millisToUnit)(millisDifferent, TimeUnits.SECOND, 5);
        return `${fiveSeconds} seconds ago`;
    }
    else if (millisDifferent < (TimeUnits.SECOND * 60)) {
        const fifteenSeconds = (0, exports.millisToUnit)(millisDifferent, TimeUnits.SECOND, 15);
        return `${fifteenSeconds} seconds ago`;
    }
    else if (millisDifferent < (TimeUnits.MINUTE * 6)) {
        const minutes = (0, exports.millisToUnit)(millisDifferent, 60000);
        return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    }
    else {
        return 'more than 5 minutes ago';
    }
};
exports.getLastSavedMessage = getLastSavedMessage;
/**
 * Calculate the string to display for published status.
 *
 * @param since : Date that is the last published time.
 */
const getLastPublishedMessage = (since) => {
    const now = new Date();
    const delta = now.getTime() - since.getTime();
    const units = Object.entries(TimeUnits)
        .filter(([key, value]) => typeof value === 'number')
        .sort((a, b) => a[1] > b[1] ? -1 : 1);
    for (const [name, value] of units) {
        if (delta > value) {
            const count = Math.floor(delta / value);
            return `${count} ${name.toLowerCase()}${count > 1 ? 's' : ''} ago`;
        }
    }
    return 'less than a second ago';
};
exports.getLastPublishedMessage = getLastPublishedMessage;
/**
 * Takes a UTC date and converts to local timezone
 * @param date the UTC date to convert to locale
 */
const fromUTC = (date) => {
    const d = new Date(date);
    const offset = new Date().getTimezoneOffset();
    return new Date(d.setMinutes(d.getMinutes() - offset));
};
exports.fromUTC = fromUTC;
//# sourceMappingURL=time.js.map